import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { MembersSegmentChipListFormComponent } from './members-segment-chip-list-form/members-segment-chip-list-form.component';
import { TtcChipListFormComponent } from './ttc-chip-list-form.component';

@NgModule({
  declarations: [MembersSegmentChipListFormComponent, TtcChipListFormComponent],
  exports: [MembersSegmentChipListFormComponent, TtcChipListFormComponent],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    ReactiveFormsModule,
    TranslationLookupModule,
  ],
})
export class TtcChipListFormModule {}
